import axios from "axios";
import { getAuthToken } from "./cookieUtils";
import { getAuthHeaders } from "./authUtils";

// Function to get LinkedIn profiles list
export const getLinkedInProfilesList = async (params = {}) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const queryParams = new URLSearchParams();

    // Add query parameters
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.active_only !== undefined) queryParams.append('active_only', params.active_only);
    if (params.search) queryParams.append('search', params.search);
    
    const url = `${baseURL}/linkedin-profiles?${queryParams.toString() || `t=${Date.now()}`}`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get LinkedIn profile by ID
export const getLinkedInProfileById = async (profileId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/linkedin-profiles/${profileId}`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to create a new LinkedIn profile
export const createLinkedInProfile = async (profileData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();

  try {
    const response = await axios.post(
      `${baseURL}/linkedin-profiles`,
      profileData,
      {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
      }
    );
    console.log("LinkedIn profile created successfully:", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to update an existing LinkedIn profile
export const updateLinkedInProfile = async (profileId, updateData) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/linkedin-profiles/${profileId}`;

    const response = await axios.put(url, updateData, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to delete a LinkedIn profile
export const deleteLinkedInProfile = async (profileId) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/linkedin-profiles/${profileId}`;

    const response = await axios.delete(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to search LinkedIn profiles
export const searchLinkedInProfiles = async (searchTerm, limit = 50) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/linkedin-profiles/search?q=${encodeURIComponent(searchTerm)}&limit=${limit}`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get LinkedIn profiles by JD ID
export const getLinkedInProfilesByJD = async (jdId, params = {}) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const queryParams = new URLSearchParams();

    if (params.limit) queryParams.append('limit', params.limit);
    if (params.skip) queryParams.append('skip', params.skip);
    
    const url = `${baseURL}/linkedin-profiles/jd/${jdId}?${queryParams.toString() || `t=${Date.now()}`}`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get LinkedIn profiles by Client ID
export const getLinkedInProfilesByClient = async (clientId, params = {}) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const queryParams = new URLSearchParams();

    if (params.limit) queryParams.append('limit', params.limit);
    if (params.skip) queryParams.append('skip', params.skip);
    
    const url = `${baseURL}/linkedin-profiles/client/${clientId}?${queryParams.toString() || `t=${Date.now()}`}`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get LinkedIn profiles by JD ID and Client ID
export const getLinkedInProfilesByJDAndClient = async (jdId, clientId, params = {}) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const queryParams = new URLSearchParams();

    if (params.limit) queryParams.append('limit', params.limit);
    if (params.skip) queryParams.append('skip', params.skip);
    
    const url = `${baseURL}/linkedin-profiles/jd/${jdId}/client/${clientId}?${queryParams.toString() || `t=${Date.now()}`}`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};

// Function to get LinkedIn profiles statistics
export const getLinkedInProfilesStatistics = async () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const Token = await getAuthToken();
  try {
    const url = `${baseURL}/linkedin-profiles/statistics`;

    const response = await axios.get(url, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      },
    });
    console.log("Response:-->", response.data);
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Error response data:", error.response.data);
      console.error("Error response status:", error.response.status);
      console.error("Error response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Error request data:", error.request);
    } else {
      console.error("Error message:", error.message);
    }
    console.error("Error config:", error.config);
    throw error;
  }
};
